const OneTimePaymentTypes = {
  UTILITIES: 'utilities',
  DEPOSIT: 'deposit',
  PRORATED_RENT: 'prorated-rent',
  LATE_FEE: 'late-fee',
  PET_FEE: 'pet-fee',
  OTHER: 'other',
  PAYMENT_PLAN: 'payment-plan',
};

export const TypesWithMonthlyLimits = [
  OneTimePaymentTypes.UTILITIES,
  OneTimePaymentTypes.OTHER,
  OneTimePaymentTypes.PET_FEE,
  OneTimePaymentTypes.LATE_FEE,
];

export default OneTimePaymentTypes;
